import React, { useState } from 'react';
import { Alert, Button, Form, Input, message, Modal, Row, Tag } from 'antd';
import { useDispatch } from 'react-redux';
import { useAuthContext, FormItemWrap } from 'react-structure-admin';
import {
  showSubscriptionPaymentMethod,
  changeSubscriptionPlan,
  openSubscriptionAvailablePaymentMethod,
  openRegularizePayment,
  openPendingPayment,
  close
} from 'stores/subscriptions/subscriptionActions';
import { Footer } from 'components';
import formatCurrency from 'util/formatters/formatCurrency';
import { CREDITCARD, display } from 'constants/types';
import SubscriptionStatus from './SubscriptionStatus';
import ResCol from 'components/forms/ResCol';
import moment from 'moment';
import { Crisp } from 'crisp-sdk-web';

const SubscriptionDetail = ({
  subscription = {},
  view,
  width = '100%',
  paddingLeft = '5%'
}) => {
  const { subscription: authSubscription } = useAuthContext();
  const { status, plan, features, paymentMethod, amount } = subscription;
  const { lastPaymentIsDue, schedulePlan, expiresAt } = authSubscription;
  const dispatch = useDispatch();
  const [acceptanceDate, setAcceptanceDate] = useState();

  const handleChangePlanClick = () => {
    dispatch(changeSubscriptionPlan());
  };

  const handleRegularizePayment = () => {
    dispatch(openRegularizePayment(authSubscription));
  };

  const handlePendingPayment = () => {
    dispatch(openPendingPayment());
  };

  const handleChangePaymentMethod = () => {
    dispatch(showSubscriptionPaymentMethod());
  };

  const handleChangeAvailablePaymentMethod = () => {
    dispatch(openSubscriptionAvailablePaymentMethod());
  };

  const allowChangePlan = () => {
    if (view) {
      return false;
    }

    if (status === 'suspended' || lastPaymentIsDue) {
      return false;
    }

    return true;
  };

  const allowRegularizePayment = () => {
    return status === 'suspended' || status === 'expired';
  };

  const hasPaymentMethod =
    paymentMethod && amount > 0 && paymentMethod?.type === CREDITCARD;

  const allowedPaymentMethods = plan.paymentMethod.filter(
    (c) => c !== paymentMethod?.type
  );

  const onSuccessGetTermAcceptance = ({ data }) => {
    const { acceptanceDate } = data.result;
    setAcceptanceDate(acceptanceDate);
  };

  const allowCancelSubscription = () => {
    return (
      status === 'active' || status === 'suspended' || status === 'expired'
    );
  };

  const handleRequestCancel = () => {
    if (status === 'active') {
      dispatch(close());
      Crisp.message.sendText('Quero cancelar minha assinatura');
      Crisp.chat.open();
    } else {
      handlePendingPayment();
    }
  };

  // useEffect(() => {
  //   dispatch(getLastTermOfUseAcceptance(tenantId, onSuccessGetTermAcceptance));
  // }, []);

  return (
    <>
      {schedulePlan ? (
        <Alert
          showIcon
          message={
            <div>
              <span>
                Sua alteração para o plano
                <strong>{` ${schedulePlan?.name} `}</strong> entrará em vigor em{' '}
                <strong>{`${moment(expiresAt).format('DD/MM/YYYY')}`}</strong>.
              </span>
            </div>
          }
        />
      ) : null}

      {subscription.plan && (
        <div className="gx-subscription-list">
          <Row>
            <ResCol span={17} md={22}>
              <div className="card" style={{ width }}>
                <div className="card-header">
                  <span>{plan.name}</span>
                  <h1>
                    {amount === 0 ? (
                      <span>Grátis</span>
                    ) : (
                      <span>{formatCurrency(amount)}</span>
                    )}
                  </h1>
                </div>
                <div className="card-body" style={{ paddingLeft }}>
                  <div>
                    <ul>
                      {features.map((f) => (
                        <li key={f.id}>{f.description}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className="gx-m-2">
                {acceptanceDate && (
                  <div
                    className="gx-fs-md gx-mb-1"
                    style={{ fontSize: '12px', paddingTop: '5px' }}
                  >
                    Termos de Uso aceito em {formartDateTimeUTC(acceptanceDate)}
                    <Tooltip title="Baixar Comprovante de Aceite Digital">
                      <Link
                        to={`/public/term-of-use/${tenantId}/acceptance/pdf`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFileSignature
                          color="#545454"
                          style={{ marginLeft: '4px', marginBottom: '-2px' }}
                        />
                      </Link>
                    </Tooltip>
                  </div>
                )}
              </div> */}
            </ResCol>
            <ResCol span={7} md={24}>
              {!view ? (
                <div>
                  <div className="gx-m-2">
                    <div className="gx-fs-lg gx-mb-1 gx-mr-2">Situação</div>
                    <SubscriptionStatus status={status} />
                  </div>
                  {hasPaymentMethod ? (
                    <div className="gx-m-2">
                      <div className="gx-mb-1">
                        <span className="gx-fs-lg gx-mr-2">
                          Forma de Pagamento
                        </span>
                      </div>
                      <Tag>{display[paymentMethod?.type]}</Tag>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </ResCol>
          </Row>
        </div>
      )}

      <Footer>
        {allowRegularizePayment() && (
          <Button style={{ margin: 0 }} onClick={handleRegularizePayment}>
            Regularizar pagamento
          </Button>
        )}
        {allowedPaymentMethods.length !== 0 ? (
          <Button
            style={{ margin: 0 }}
            onClick={handleChangeAvailablePaymentMethod}
          >
            Alterar forma de pagamento
          </Button>
        ) : null}
        {hasPaymentMethod ? (
          <Button style={{ margin: 0 }} onClick={handleChangePaymentMethod}>
            Alterar cartão de crédito
          </Button>
        ) : null}
        {allowChangePlan() && (
          <Button
            style={{ margin: 0 }}
            onClick={handleChangePlanClick}
            disabled={!!schedulePlan}
          >
            Alterar Plano
          </Button>
        )}
        {allowCancelSubscription() && (
          <Button onClick={handleRequestCancel} disabled={!!schedulePlan}>
            Cancelar Assinatura
          </Button>
        )}
      </Footer>
    </>
  );
};

export default SubscriptionDetail;
